import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Upload } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import isArray from 'lodash/isArray';
import size from 'lodash/size';
import isEmpty from 'lodash/isEmpty';
import { instance } from 'store/utils';
import DownloadSingleFile from 'components/downloadSingleFile';
import {
  setValidity,
  updateFormField,
  triggerLoading,
  clearExcelError,
  deleteDocument,
  saveTask,
} from 'store/forms/actions';
import { UploadLabel, UploadTitle, File, ClickUpload } from './components';
import { isNil, pick } from 'lodash';
import { handleSave, isBeneficiary } from 'utils';

const { Dragger } = Upload;

const Draggable = ({
  item,
  task,
  value,
  key = '',
  index,
  ind, 
  subFileCode, 
  subgroup, 
  updateDocs,
  group,
  mode,
  disabled,
  withOpen,
  handleFile = () => {},
  ...rest
}) => {
  const {
    label,
    subLabel,
    linkText,
    multiple,
    single,
    singlePerRow,
    fileCode,
    required,
    fileAccepts,
    fileLimit,
  } = item;
  const [percent, setPercent] = useState(0);
  const [errorFile, setError] = useState('');
  const [notAccepted, setNotAccepted] = useState(false);
  const [uploadingError, setUploadingError] = useState(false);
  const [uploadingErrorMessage, setUploadingErrorMessage] = useState(false);
  const params = useParams();
  const isExcelToParse = fileCode === 'ibaBusXls';
  const dispatch = useDispatch();
  const forms = useSelector(state => state.forms);
  const user = useSelector(state => state.user);
  // const docs = useSelector(state => state.forms[group]);
  const docs = useSelector(state => subgroup ? state.forms[group][subgroup] : state.forms[group]);
  const excelError = useSelector(state => state.forms.excelError);
  const shouldDisplayExcelError =
    !isEmpty(excelError) && excelError.name && isExcelToParse;

    const [queue, setQueue] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [isUploading, setIsUploading] = useState(false);

  const [newDocs, setNewDocs] = useState([]);
  let registerLabel = null;
  const [respData, setRespData] = useState();
  
  useEffect(() => {
    if (multiple || single || singlePerRow) {
      if (docs[fileCode]) {
        setNewDocs([...docs[fileCode]]);
      }
    }
  }, [docs]);

  const saveData = {
    state: { ...forms },
    dispatch,
    saveTask,
    taskId: params?.taskId,
    formId: forms?.formId,
    isSaved: forms?.carrier?.rejectReasons?.isSubmitValid ? true : false,
  };

  const isInvalidType = (type) => {
    return !(
          type.includes('pdf') ||
          type.includes('sheet') ||
          // type.includes('png') ||
          // type.includes('jpeg') ||
          (type.includes('document') && !type.includes('presentation')) ||
          type.includes('ms-excel')
        );
  };

  useEffect(() => {
    if (!isUploading && !errorFile && (currentFileIndex < queue.length)) {
      uploadNextFile();
    }
  }, [isUploading, currentFileIndex, queue]);

  const uploadNextFile = () => {
    const nextFile = queue[currentFileIndex];
    if (nextFile) {
      handleUpload(nextFile);
    }
  };

  const handleUpload = (file) => {
    setIsUploading(true);
    setPercent(0);
    dispatch(triggerLoading(true));

    const formData = new FormData();
    formData.append("file", file);

    instance
    .post(
      `/app/rest/tasks/${params.taskId}/raw-contents`, formData)
      .then(response => {
        handleFileUploadSuccess(response.data)
        setPercent(100);
        setIsUploading(false);
        // setCurrentFileIndex(prev => prev + 1); // Move to the next file in queue

      })
      .catch(error => {
        setIsUploading(false);
        console.error('Upload failed:', error);
        setQueue([]);
        setCurrentFileIndex(0);
        setError(file.name);
        setUploadingError(true);
        setUploadingErrorMessage('Upload failed');
        dispatch(triggerLoading(false));

      });
  };

  const handleFileUploadSuccess = (responseData) => {
    setCurrentFileIndex(prev => prev + 1);

    const { size, mimeType } = responseData;

    const fileExceeds = size > fileLimit * 1024 * 1024; //1MB=1024×1024bytes
    if (fileExceeds) {
      setQueue([]);
      setError(responseData.name);
      dispatch(triggerLoading(false));
      return;
    }

    if (isInvalidType(mimeType)) {
      setQueue([]);
      setError(responseData.name);
      setNotAccepted(true);
      dispatch(triggerLoading(false));
      return;
    }
    setPercent(1);
    if (responseData) {
      const response = { ...responseData, 'field': subFileCode };

      if (multiple || single || singlePerRow) {
        if (docs[fileCode] && docs[fileCode][index] === '') {
          const updatedDocs = newDocs;
          updatedDocs[index] = response;
          setNewDocs(updatedDocs);
        }
      }

    
      const newValue = multiple
        ? docs[fileCode]
          ? [...docs[fileCode], response]
          : [response]
        : single || singlePerRow
        ? docs[fileCode]
          ? docs[fileCode][index] !== ''
            ? [...docs[fileCode], response]
            : newDocs
          : [response]
        : response;
        
        if(subgroup){
          updateDocs({
            response: multiple
            ? docs[ind][subFileCode]
              ? [...docs[ind][subFileCode], response]
              : [response]
            : response})
        }else{
          dispatch(
            updateFormField({
              group,
              key: fileCode,
              value: newValue,
            })
          );
        }
      if (isExcelToParse) {

        // dispatch(
        //   parseExcel({
        //     id: responseId,
        //     name: info.file.name,
        //     callback: success => {
        //       setPercent(100);
        //       dispatch(triggerLoading(false));
        //     },
        //   })
        // );
      } else {
        setPercent(100);
        dispatch(triggerLoading(false));
      }

    }
  };


    const beforeUpload = (file) => {
      const { size, type } = file;

      const fileExceeds = size > fileLimit * 1024 * 1024; //1MB=1024×1024bytes
      if (fileExceeds) {
        setQueue([]);
        setCurrentFileIndex(0);
        setError(file.name);
        setNotAccepted(false);
        dispatch(triggerLoading(false));
        return false;
      }
      
      if (isInvalidType(type)) {
        setQueue([]);
        setCurrentFileIndex(0);
        setError(file.name);
        setNotAccepted(true);
        dispatch(triggerLoading(false));
        return false;
      }

      if(errorFile){
        setQueue([]);
        setCurrentFileIndex(0);
      }else{
        setQueue(prevQueue => [...prevQueue, file]);
      }

      return false; // Prevent automatic upload
    };

  const props = {
    name: 'file',
    multiple,
    withCredentials: true,
    accept: fileAccepts,
    // action:'/' +process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH + `${`/app/rest/tasks/${params.taskId}/raw-contents`}`,
    beforeUpload,
    openFileDialogOnClick:
      single ||
      singlePerRow ||
      multiple ||
      (!multiple && size(docs[fileCode]) < 1),
    showUploadList: false,
    progress: {
      format: percent => percent && `${parseFloat(percent.toFixed(2))}%`,
    },
  };

  const handleDeleteDocument = (event, file) => {
    event.stopPropagation();
    event.preventDefault();

    const newValue = multiple
      ? size(docs[fileCode]) === 1
        ? null
        : Array.isArray(docs[fileCode])
        ? docs[fileCode]?.filter(doc => doc.id !== file.id)
        : null
      : single || singlePerRow
      ? size(docs[fileCode]) === 1
        ? ''
        : docs[fileCode]?.map(doc => {
            if (!isNil(doc) && doc.id === file.id) {
              return '';
            }
            return doc;
          })
      : null;

      if(subgroup){
        updateDocs({
          file: multiple
          ? size(docs[ind][subFileCode]) === 1
            ? null
            : docs[ind][subFileCode].filter(doc => doc.id !== file.id)
          : null
        })
      }

    if (mode === 'ktp-uploads') {
      dispatch(
        updateFormField({
          group,
          key: fileCode,
          value: newValue,
        })
      );
      handleFile();
    } else {
      dispatch(
        deleteDocument({
          docId: fileCode.includes("cmp") ? file.id
            : Array.isArray(docs[fileCode])
            ? docs[fileCode]?.find(doc => doc.id === file.id)?.id
            : docs[fileCode]?.id,
          group,
          key: fileCode,
          value: newValue,
        })
      );
      if (!fileCode.includes('cmp'))
        dispatch(
          updateFormField({
            group,
            key: fileCode,
            value: newValue,
          })
        );
      //autosave
      // const dataToSave = { ...saveData };
      // dataToSave.state.documents[fileCode] = newValue;
      // handleSave(saveData);
    }

    // if (isExcelToParse) {
    //   dispatch(clearExcelData());
    // }
  };

  useEffect(() => {
    if (fileCode === 'certificationDocs') {
      // || fileCode === 'ibaDocs'
      if (docs.certificationDocs) {
        //docs.ibaDocs &&
        dispatch(setValidity({ group: 'documents', value: true }));
      } else {
        dispatch(setValidity({ group: 'documents', value: false }));
      }
    }
  }, [docs, fileCode, dispatch]);

  return (
    <div className={`ant-drag-container ${disabled ? 'upload-disabled' : ''}`}>
      {label && isNil(registerLabel) && (
        <UploadLabel
          label={label}
          subLabel={subLabel}
          linkText={linkText}
          fileCode={fileCode}
          required={required}
        />
      )}
      {!isNil(registerLabel) && (
        <UploadLabel
          label={registerLabel}
          subLabel={subLabel}
          linkText={linkText}
          fileCode={fileCode}
          required={required}
        />
      )}
      <Dragger
        {...props}
        {...rest}
        disabled={disabled}
        id={fileCode}
        className={`custom-drag ${
          (docs?.[fileCode] && multiple && size(docs?.[fileCode]) > 2) || (subgroup && docs?.[ind][subFileCode])
            ? 'with-scroll-x'
            : ''
        }`}
      >
        <UploadTitle />
        {errorFile || shouldDisplayExcelError ? (
          <File
            error
            file={{
              notAccepted,
              fileLimit,
              description: uploadingError ?
                uploadingErrorMessage
              : notAccepted
                ? 'Ο τύπος του αρχείου δεν είναι αποδεκτός'
                : 'The uploaded file is too large.',
              name: shouldDisplayExcelError ? excelError.name : errorFile,
            }}
            handleDeleteDocument={(event, file) => {
              event.stopPropagation();
              event.preventDefault();
              setError('');
              if (shouldDisplayExcelError) {
                dispatch(clearExcelError());
                dispatch(
                  updateFormField({ group, key: 'ibaBusXls', value: null })
                );
              }
            }}
          />
        ) : docs[fileCode] ? (
          isArray(docs[fileCode]) && !single ? (
            <div className="d-flex custom-drag__filelist-container">
              {docs[fileCode].map((file, index) => (
                <File
                  key={index}
                  file={file}
                  handleDeleteDocument={handleDeleteDocument}
                  percent={percent}
                />
              ))}
            </div>
          ) : single ? (
            docs[fileCode][index] && !isNil(docs[fileCode][index].name) ? (
              <div className="d-flex custom-drag">
                <File
                  key={index}
                  file={docs[fileCode][index]}
                  handleDeleteDocument={handleDeleteDocument}
                  percent={percent}
                />
              </div>
            ) : (
              <ClickUpload fileAccepts={fileAccepts} fileLimit={fileLimit} />
            )
          ) : docs[fileCode][index] && !isNil(docs[fileCode][index].name) ? (
            <div className="">
              {docs[fileCode].map((file, index) => (
                <div className="d-flex mt-2">
                  <File
                    key={index}
                    file={docs[fileCode][index]}
                    handleDeleteDocument={handleDeleteDocument}
                    percent={percent}
                  />
                  <div className="download-icon ml-4">
                    <DownloadSingleFile
                      item={{
                        fileCode: fileCode,
                        fileLimit: 100,
                        single: true,
                      }}
                      task={task}
                      index={index}
                      group={group}
                      withOpen={withOpen}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <File
              file={docs[fileCode]}
              handleDeleteDocument={handleDeleteDocument}
              percent={percent}
            />
          )
        ) 
        :
        subgroup && !isEmpty(docs[ind][subFileCode])  ? (         
          isArray(docs[ind][subFileCode]) ? (
            <div className="d-flex custom-drag__filelist-container">
              {docs[ind][subFileCode].map((file, index) => (
                <File
                  key={index}
                  file={file}
                  //file={docs[ind][subFileCode]}
                  ind={ind}
                  subFileCode={subFileCode}
                  handleDeleteDocument={handleDeleteDocument}
                  percent={percent}
                />
              ))}
            </div>
          ) : (
            <File
              file={docs[ind][subFileCode]}
              ind={ind}
              subFileCode={subFileCode}
              handleDeleteDocument={handleDeleteDocument}
              percent={percent}
            />
          )
        )
        : (
          <ClickUpload fileAccepts={fileAccepts} fileLimit={fileLimit} />
        )}
      </Dragger>
    </div>
  );
};

Draggable.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  linkText: PropTypes.string,
  group: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default Draggable;
